"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClearInput = exports.StyledSearchContainer = exports.StyledInputError = exports.InputContainer = exports.StyledInput = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _searchIcon = _interopRequireDefault(require("../../assets/searchIcon.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 10px;\n  color: #CBCED6;\n  font-size: 10px;\n  top: 11px;\n\n  &:hover {\n    cursor: pointer;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: -18px;\n  left: 0;\n  font-size: 10px;\n  color: #bdbcbc;\n  opacity: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  border-radius: 3px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  background: url('", "') 12px 12px no-repeat;\n  border: none;\n  width: 100%;\n  outline: none;\n  text-indent: 8px;\n  padding: 6px;\n  padding-bottom: 8px;\n  border-radius: 30px;\n  width: 100%;\n  font-family: Brandon;\n  margin-bottom: 6px;\n  font-size: 12px;\n  font-weight: 100;\n  background-color: #F3F4F5;\n  padding-left: 20px;\n\n  ::placeholder {\n    font-weight: normal;\n    color: #afafaf;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledInput = _styledComponents["default"].input(_templateObject(), _searchIcon["default"]);

exports.StyledInput = StyledInput;

var InputContainer = _styledComponents["default"].div(_templateObject2());

exports.InputContainer = InputContainer;

var StyledInputError = _styledComponents["default"].div(_templateObject3(), function (_ref) {
  var shown = _ref.shown;
  return shown ? '1' : 0;
});

exports.StyledInputError = StyledInputError;

var StyledSearchContainer = _styledComponents["default"].div(_templateObject4());

exports.StyledSearchContainer = StyledSearchContainer;

var ClearInput = _styledComponents["default"].div(_templateObject5());

exports.ClearInput = ClearInput;

//# sourceMappingURL=styled.js.map